import { createContext, useContext, useEffect, useState } from 'react';
import Notification from 'components/Notification';
import PropTypes from 'prop-types';
import React from 'react';

const NotificationContext = createContext({});

const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    show: false,
    error: false,
    title: '',
    message: ''
  });

  const closeNotification = () => {
    setNotification({
      ...notification,
      show: false
    });
  };

  useEffect(() => {
    if (notification.show) {
      setTimeout(() => {
        setNotification({ ...notification, show: false });
      }, 3000);
    }
  }, [notification.show]);

  return (
    <NotificationContext.Provider
      value={{ notification, setNotification, closeNotification }}
    >
      {children}
      <Notification
        notification={notification}
        closeNotification={closeNotification}
      />
    </NotificationContext.Provider>
  );
};

const useNotif = () => useContext(NotificationContext);

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { NotificationProvider, useNotif };
